import { connect } from 'react-redux';
import LoginWrapper from "../components/general/LoginWrapper";
import { requestLogin } from "../store/actions/login";

const mapStateToProps = state => {
    return {
        todos: state.todos,
        login: state.loginR
    };
};

const mapDispatchToProps = dispatch => {
    return {
        requestLogin: body => dispatch(requestLogin(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWrapper);


// WEBPACK FOOTER //
// ./src/containers/Login.js